import { useScrollReveal } from "@/hooks/useScrollReveal";

const values = [
  { icon: "ri-shield-star-line", title: "Excelência", desc: "Padrão de qualidade incomparável em cada detalhe do serviço." },

  { icon: "ri-time-line", title: "Pontualidade", desc: "Comprometimento absoluto com horários e prazos acordados." },
  { icon: "ri-customer-service-2-line", title: "Suporte 24/7", desc: "Equipe disponível a qualquer hora para atender sua necessidade." },
  { icon: "ri-translate-2", title: "Motoristas Bilíngues", desc: "Nossa equipe fala português e inglês para atender clientes nacionais e internacionais." },
];

export default function AboutSection() {
  const imgReveal = useScrollReveal({ threshold: 0.1 });
  const contentReveal = useScrollReveal({ threshold: 0.1 });
  const statsReveal = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="about" className="bg-black py-24 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left - Image */}
          <div
            ref={imgReveal.ref}
            className={`flex-1 relative transition-all duration-700 ${
              imgReveal.isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"
            }`}
          >
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/d67fb1795557dee1da7634fb223b699c.png"
                alt="Motorista Executivo Transporte Menezes"
                className="w-full h-[500px] object-cover object-top rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-lg"></div>
            </div>

            {/* Floating card */}
            <div className="absolute -bottom-6 -right-6 bg-slate-300 rounded-lg p-6 shadow-2xl hidden lg:block">
              <div className="text-black font-bold text-4xl">18</div>
              <div className="text-black/80 text-sm font-medium mt-1">Anos de<br />Experiência</div>
            </div>

            {/* Silver border accent */}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-slate-400 rounded-tl-lg hidden lg:block"></div>
          </div>

          {/* Right - Content */}
          <div
            ref={contentReveal.ref}
            className={`flex-1 transition-all duration-700 delay-200 ${
              contentReveal.isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"
            }`}
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-12 bg-slate-400"></div>
              <span className="text-slate-300 text-sm font-semibold tracking-widest uppercase">
                Quem Somos
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Tradição e{" "}
              <span className="text-slate-300">Sofisticação</span>
              <br />no Transporte
            </h2>

            <p className="text-gray-400 text-base leading-relaxed mb-6">
              A <strong className="text-slate-300">Transporte Menezes</strong> nasceu da paixão por oferecer mobilidade de alto padrão. Com mais de 18 anos de experiência, nos tornamos referência em transporte executivo corporativo, atendendo clientes que exigem o melhor.
            </p>

            <p className="text-gray-400 text-base leading-relaxed mb-6">
              Nossa frota é composta pelos mais sofisticados veículos do mercado, e nossa equipe de motoristas é rigorosamente selecionada e treinada para garantir uma experiência única em cada viagem.
            </p>

            {/* Bilingual highlight */}
            <div className="flex items-center gap-4 bg-slate-400/10 border border-slate-400/30 rounded-lg px-5 py-4 mb-10">
              <div className="w-10 h-10 flex items-center justify-center bg-slate-400/20 rounded-md flex-shrink-0">
                <i className="ri-translate-2 text-slate-300 text-xl"></i>
              </div>
              <div>
                <div className="text-slate-200 font-semibold text-sm">Motoristas Bilíngues</div>
                <div className="text-gray-400 text-xs mt-0.5">Atendimento em Português &amp; Inglês — perfeito para clientes internacionais.</div>
              </div>
            </div>

            {/* Values Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {values.map((val, idx) => (
                <div key={idx} className="flex items-start gap-4 p-4 bg-zinc-900 border border-zinc-800 rounded-lg hover:border-slate-500/40 transition-all duration-300">
                  <div className="w-10 h-10 flex items-center justify-center bg-slate-400/15 rounded-md flex-shrink-0">
                    <i className={`${val.icon} text-slate-300 text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-white font-semibold text-sm">{val.title}</div>
                    <div className="text-gray-500 text-xs mt-1 leading-relaxed">{val.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Stats Bar */}
        <div
          ref={statsReveal.ref}
          className={`mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 transition-all duration-700 ${
            statsReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          {[
            { value: "5.000+", label: "Clientes Atendidos" },
            { value: "50.000+", label: "Viagens Realizadas" },
            { value: "18", label: "Anos no Mercado" },
            { value: "100%", label: "Satisfação Garantida" },
          ].map((stat, idx) => (
            <div
              key={idx}
              className="text-center p-6 bg-zinc-900 border border-zinc-800 rounded-lg hover:border-slate-500/40 transition-all duration-300"
            >
              <div className="text-3xl md:text-4xl font-bold text-slate-300 mb-2">{stat.value}</div>
              <div className="text-gray-400 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
